export const redirectPath = '/jira/errors/project-archived';
